import { render } from "./DeliveryRecords.vue?vue&type=template&id=31a73ded&scoped=true"
import script from "./DeliveryRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./DeliveryRecords.vue?vue&type=script&setup=true&lang=js"

import "./DeliveryRecords.vue?vue&type=style&index=0&id=31a73ded&scoped=true&lang=css"
import "./DeliveryRecords.vue?vue&type=style&index=1&id=31a73ded&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a73ded"],['__file',"src/views/exhibitionManage/components/registrationSubscription/DeliveryRecords.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31a73ded"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31a73ded', __exports__)) {
    console.log('reload')
    api.reload('31a73ded', __exports__)
  }
  
  module.hot.accept("./DeliveryRecords.vue?vue&type=template&id=31a73ded&scoped=true", () => {
    console.log('re-render')
    api.rerender('31a73ded', render)
  })

}


export default __exports__